var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "z-number-range", style: { width: _vm.width } },
    [
      _c("el-input-number", {
        attrs: {
          "controls-position": "right",
          placeholder: _vm.startPlaceholder,
        },
        model: {
          value: _vm.value[_vm.startKey],
          callback: function ($$v) {
            _vm.$set(_vm.value, _vm.startKey, $$v)
          },
          expression: "value[startKey]",
        },
      }),
      _c("span", { staticClass: "z-number-range__split" }, [_vm._v("~")]),
      _c("el-input-number", {
        attrs: {
          "controls-position": "right",
          placeholder: _vm.endPlaceholder,
        },
        model: {
          value: _vm.value[_vm.endKey],
          callback: function ($$v) {
            _vm.$set(_vm.value, _vm.endKey, $$v)
          },
          expression: "value[endKey]",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }